export default class BaseRestEntity {
  public id = ''
  public name = ''
  public lastUpdateEpochMillis = ''
}
